import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { ClientColorTrigger as ColorTrigger } from "~/components/bloks/ColoredSectionBlok/ClientColorTrigger";
import type { ColoredSectionStoryblok } from "~/generated/sb/blok-types";

export const ColoredSectionBlok = ({ blok, preview }: BlokProps<ColoredSectionStoryblok>) => {
	return (
		<BlokWrap asChild editable={blok}>
			<ColorTrigger blok={blok}>
				{blok.content.map((b) => (
					<StoryblokComponent blok={b} key={b._uid} preview={preview} />
				))}
			</ColorTrigger>
		</BlokWrap>
	);
};
